(function () {
  'use strict';

  var JDGM_SECTION_SELECTOR = [
    '[data-section-type*="judgeme"]',
    '[data-section-type*="jdgm"]',
    '[id^="shopify-section-"] .jdgm-rev-widg',
    '[id^="shopify-section-"] .jdgm-testimonials',
    '[id^="shopify-section-"] [class*="jdgm-carousel"]',
    '[id^="shopify-section-"] [class*="judgeme"]'
  ].join(', ');

  function findReviewsSection() {
    var nodes = document.querySelectorAll(JDGM_SECTION_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].closest('.kipor-rating')) {
        return nodes[i].closest('[id^="shopify-section-"]') || nodes[i];
      }
    }
    return null;
  }

  function smoothScrollTo(el) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 24;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function syncRatings() {
    document.querySelectorAll('.kipor-rating').forEach(function (rating) {
      var badge = rating.querySelector('.jdgm-prev-badge');
      var hasReviews = false;

      if (badge) {
        var countAttr = badge.getAttribute('data-number-of-reviews');
        var count = countAttr ? parseInt(countAttr, 10) : 0;
        if (count > 0) {
          hasReviews = true;
        }
      }

      if (hasReviews) {
        rating.classList.add('kipor-rating--has-reviews');
      } else {
        rating.classList.remove('kipor-rating--has-reviews');
      }
    });
  }

  function initSync() {
    syncRatings();
    setTimeout(syncRatings, 800);
    setTimeout(syncRatings, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSync);
  } else {
    initSync();
  }

  document.addEventListener('click', function (e) {
    var ratingEl = e.target.closest('.kipor-rating');
    if (!ratingEl) return;

    if (ratingEl.classList.contains('kipor-rating--link')) {
      var url = ratingEl.getAttribute('data-rating-link');
      if (url) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = url;
      }
      return;
    }

    if (ratingEl.classList.contains('kipor-rating--scroll')) {
      e.preventDefault();
      var target = findReviewsSection();
      if (target) smoothScrollTo(target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var ratingEl = e.target.closest('.kipor-rating');
    if (!ratingEl) return;
    e.preventDefault();
    ratingEl.click();
  });

  function handleHashOnLoad() {
    if (window.location.hash !== '#kipor-reviews') return;
    var attempts = 0;
    var maxAttempts = 20;
    var interval = setInterval(function () {
      var target = findReviewsSection();
      if (target) {
        clearInterval(interval);
        smoothScrollTo(target);
      } else if (++attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleHashOnLoad);
  } else {
    handleHashOnLoad();
  }
})();